import VerticalSlider from './VerticalSlider'
export default VerticalSlider
